import { render, staticRenderFns } from "./crear-posgrado.vue?vue&type=template&id=f3f876da"
import script from "./crear-posgrado.vue?vue&type=script&lang=js"
export * from "./crear-posgrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports